import { styled } from "@mui/material/styles";
import { CircularProgress } from "@mui/material";

export const RoundedCircularProgress = styled(CircularProgress)({
  "& .MuiCircularProgress-circle": {
    strokeLinecap: "round",
  },
});
